//
//
//
//
//
//
//
//
//
//
//
//

export default {
  setup() {
    const items = ['foo', 'bar', 'fizz', 'buzz']
    const value = ['foo', 'bar', 'fizz', 'buzz']

    return { items, value }
  },
}
